import React from 'react';
import { string, func, } from 'prop-types';
import clickToHide from '../hoc/clickToHideHOC';

const PropTypes = {
  msg: string,
  handleHideComponent: func,
};
const DefaultProps = {
  msg: '',
  handleHideComponent: () => {},
};

export const ErrBlock = ({
  msg,
  handleHideComponent,
}) => (
  <div
    style={ {
      lineHeight: 2,
      backgroundColor: '#fef0f0',
      padding: '5px 15px',
      boxShadow: '1px 1px 10px rgba(0,0,0,.22)',
      color: '#e53a45',
      position: 'relative',
    } }
  >
    <i
      className="fa fa-exclamation-circle"
      style={ {
        marginRight: 5,
        fontSize: 18,
      } }
    />
    錯誤訊息
    <br />
    <span style={ { color: '#f8081a', fontStyle: 'italic', } }>{ msg }</span>
    <i
      className="fa fa-times-circle"
      onClick={ handleHideComponent }
      style={ {
        position: 'absolute',
        right: 15,
        top: 15,
        cursor: 'pointer',
      } }
    />
  </div>
);

ErrBlock.propTypes = PropTypes;
ErrBlock.defaultProps = DefaultProps;

export default clickToHide(ErrBlock);



// WEBPACK FOOTER //
// ./src/components/ErrorToast/index.js